/* REORA — minimal reveal-on-scroll + sticky buy bar. No dependencies.
   Rules: reveal instantly in the theme editor, under reduced motion,
   and whenever IntersectionObserver is unavailable. Content is never
   hidden without JavaScript. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- reora-reveal ---------- */
  if (!customElements.get('reora-reveal')) {
    var style = document.createElement('style');
    style.textContent =
      'reora-reveal{display:block}' +
      'reora-reveal[data-arm]{opacity:0;translate:0 14px;transition:opacity 420ms ease,translate 420ms ease;transition-delay:var(--reora-delay,0ms)}' +
      'reora-reveal[data-arm][data-in]{opacity:1;translate:0 0}';
    document.head.appendChild(style);

    var observer = null;
    if ('IntersectionObserver' in window && !reduceMotion.matches && !designMode) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.setAttribute('data-in', '');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );
    }

    var ReoraReveal = function () {
      return Reflect.construct(HTMLElement, [], ReoraReveal);
    };
    ReoraReveal.prototype = Object.create(HTMLElement.prototype, {
      connectedCallback: {
        value: function () {
          var el = this;
          if (!observer) return; /* stay visible */
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
            return; /* already in view on load: no animation */
          }
          el.setAttribute('data-arm', '');
          observer.observe(el);
        }
      },
      disconnectedCallback: {
        value: function () {
          if (observer) observer.unobserve(this);
          this.removeAttribute('data-arm');
          this.removeAttribute('data-in');
        }
      }
    });
    Object.setPrototypeOf(ReoraReveal, HTMLElement);
    customElements.define('reora-reveal', ReoraReveal);

    /* If the user switches to reduced motion mid-session, reveal everything. */
    var onChange = function () {
      if (!reduceMotion.matches) return;
      document.querySelectorAll('reora-reveal[data-arm]').forEach(function (el) {
        el.setAttribute('data-in', '');
      });
    };
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onChange);

    /* Theme editor: sections re-render constantly — always show instantly. */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('reora-reveal[data-arm]').forEach(function (el) {
        el.setAttribute('data-in', '');
      });
    });
  }

  /* ---------- reora-sticky ---------- */
  if (!customElements.get('reora-sticky')) {
    var ReoraSticky = function () {
      return Reflect.construct(HTMLElement, [], ReoraSticky);
    };
    ReoraSticky.prototype = Object.create(HTMLElement.prototype, {
      connectedCallback: {
        value: function () {
          var el = this;
          /* Theme editor: keep the bar visible so it can be selected and edited. */
          if (designMode) {
            el.hidden = false;
            el.setAttribute('data-show', '');
            return;
          }
          var watch = document.querySelector(el.getAttribute('data-watch') || '.reora-hero');
          var hideSel = el.getAttribute('data-hide-near') || '';
          var hideNear = hideSel ? document.querySelector(hideSel) : null;
          if (!('IntersectionObserver' in window) || !watch) {
            /* No way to know scroll context: keep the bar available. */
            el.hidden = false;
            el.setAttribute('data-show', '');
            return;
          }
          el.hidden = false; /* in the DOM, but translated off-screen until data-show */
          var watchVisible = true;
          var nearVisible = false;
          var update = function () {
            if (watchVisible || nearVisible) {
              el.removeAttribute('data-show');
            } else {
              el.setAttribute('data-show', '');
            }
          };
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.target === watch) watchVisible = entry.isIntersecting;
                if (hideNear && entry.target === hideNear) nearVisible = entry.isIntersecting;
              });
              update();
            },
            { threshold: 0.05 }
          );
          io.observe(watch);
          if (hideNear) io.observe(hideNear);
          this._reoraIo = io;
        }
      },
      disconnectedCallback: {
        value: function () {
          if (this._reoraIo) {
            this._reoraIo.disconnect();
            this._reoraIo = null;
          }
        }
      }
    });
    Object.setPrototypeOf(ReoraSticky, HTMLElement);
    customElements.define('reora-sticky', ReoraSticky);
  }
})();
